import { reactive } from "vue";

const customObj = {
  type: "tips", // tips, error, warning, success
  title: "消息提示", // 标题
  content: "提示信息", // 提示信息
  confirmText: "确定", // 确定按钮文本
  showConfirm: true, // 是否显示确定按钮
  confirmFun: () => {
    customData.showCustomPopup = false;
    Object.assign(customData, customObj);
  }, // 确定按钮回调
  cancelText: "取消", // 取消按钮文本
  showCancel: true, // 是否显示取消按钮
  cancelFun: () => {
    customData.showCustomPopup = false;
    Object.assign(customData, customObj);
  }, // 取消按钮回调
  showMask: true, // 是否显示遮罩
};

const customData = reactive({
  showCustomPopup: false,
  ...Object.assign({}, customObj),
});

const openCustomPopup = (options) => {
  if (options.cancelFun) {
    const fun = options.cancelFun;
    options.confirmFun = () => {
      customObj.cancelFun();
      fun();
    };
  }
  if (options.confirmFun) {
    const fun = options.confirmFun;
    options.confirmFun = () => {
      customObj.cancelFun();
      fun();
    };
  }
  customData.showCustomPopup = true;
  Object.assign(customData, options);
};

export { customData, openCustomPopup };
